


export const getUserGeolocation = async () => {
    try{
    
        if (!navigator.geolocation) {
            console.error('Geolocalização não é suportada pelo seu navegador.');
            return null;
        }
    
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                return { latitude: latitude, longitude: longitude };
            },
            (error) => {
                console.error('Erro ao obter localização:', error);
                return null;
            },
            {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            }
        );

    } catch (e) {
        console.error('DEU ERRO AQUI:', e);
        return null;

    }

};